import request from '@/utils/request.ts'

// export const adduser = (data: any) =>
//   request({
//     url: '/list/loginin',
//     method: 'post',
//     data: data,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const adduser = (params: any) =>
  request({
    url: '/user/registerUser',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })